@if (isDraggingFile()) {
<div class="file-dragging">
  <ng-container
    [ngTemplateOutlet]="draggingPlaceholder() || defaultPlaceholder"
  ></ng-container>
</div>
}
<ng-content></ng-content>

<ng-template #defaultPlaceholder>{{ 'UPLOADER.DROP_OVERLAY' | translate }}</ng-template>
